import { Vector2 } from '@babylonjs/core/Maths/math.vector';

import { SystemUi } from '../System/systemUi';
import { ISize } from '../Tool/toolScreenshot';

export const setElementStyle = (el: HTMLElement, style) => {
    const keys = Object.keys(style);
    keys.forEach((s) => {
        el.style[s] = style[s];
    });
};

export class UiElement {
    protected system: SystemUi;

    protected container: HTMLElement;

    constructor(
        system: SystemUi,
        container: HTMLElement,
    ) {
        this.system = system;
        this.container = container;
        this.addDiv();
    }

    protected el: HTMLElement;

    style = {
        position: 'absolute',
        width: '50px',
        height: '50px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        'z-index': 2000,
        transition: 'opacity ease 200ms',
        pointerEvents: 'none',
        //* For test purpose
        // background: 'red',
    }

    protected setSize(size: ISize): void {
        this.el.style.width = `${size.width}px`;
        this.el.style.height = `${size.height}px`;
    }

    private addDiv() {
        this.el = document.createElement('div');
        setElementStyle(this.el, this.style);
        this.container.appendChild(this.el);
    }

    public shown = false

    public show(anim?: boolean): void {
        this.shown = true;
        this.el.style.display = 'block';
        if (anim) {
            this.el.style.opacity = '1';
        }
    }

    public hide(anim?: boolean): void {
        this.shown = false;
        if (anim) {
            this.el.style.opacity = '0';
            setTimeout(() => {
                this.el.style.display = 'none';
            }, 200);
        } else {
            this.el.style.display = 'none';
        }
    }

    protected setPosition(position: Vector2): void {
        this.el.style.left = `calc(50% + ${(Math.floor(position.x)).toString()}px)`;
        this.el.style.top = `calc(50% + ${(Math.floor(position.y)).toString()}px)`;
    }
}
